export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  {
    slug: 'system-tools',
    name: '系统工具',
    icon: 'ri-computer-line',
    description: '系统优化、清理、备份等实用工具软件，让您的电脑运行更流畅',
    count: 128,
  },
  {
    slug: 'office-software',
    name: '办公软件',
    icon: 'ri-file-text-line',
    description: '文档处理、表格编辑、演示制作等办公必备软件合集',
    count: 96,
  },
  {
    slug: 'graphic-design',
    name: '图形设计',
    icon: 'ri-palette-line',
    description: '图像处理、矢量绘图、平面设计等专业设计工具',
    count: 85,
  },
  {
    slug: 'video-editing',
    name: '视频剪辑',
    icon: 'ri-film-line',
    description: '视频编辑、特效制作、格式转换等多媒体处理工具',
    count: 73,
  },
  {
    slug: 'dev-tools',
    name: '编程开发',
    icon: 'ri-code-line',
    description: '代码编辑器、IDE、版本控制等开发者必备工具',
    count: 112,
  },
  {
    slug: 'games',
    name: '游戏娱乐',
    icon: 'ri-gamepad-line',
    description: '热门游戏、游戏辅助、模拟器等娱乐资源下载',
    count: 156,
  },
  {
    slug: 'security',
    name: '安全防护',
    icon: 'ri-shield-check-line',
    description: '杀毒软件、防火墙、隐私保护等安全防护工具',
    count: 64,
  },
  {
    slug: 'education',
    name: '学习教育',
    icon: 'ri-book-open-line',
    description: '在线课程、学习工具、考试辅导等教育资源',
    count: 91,
  },
];